import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
// import { Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { CustomSnackBarService } from 'src/app/common/snack-bar/snack-bar.service';
import { DhlFormControl } from '../../models/dhl-form-control';
import { FormService } from '../../services/form.service';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import  {Constant}  from '../../../constants/constants';
import {TranslateService} from '@ngx-translate/core';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';
import { debounceTime } from 'rxjs';
import { APP_Constants } from 'src/app/app.constant';
import { CommonConfig } from 'src/app/common/configuration/common.config';

@Component({
    selector: 'app-form-field-generic-v2',
    templateUrl: './form-field-generic-v2.component.html',
    styleUrls: ['./form-field-generic-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldGenericV2Component implements OnInit, AfterViewInit {

  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;
  @Input() toggleActiveIcon;

  @Input() fieldMetadata;
  @Output() fieldAction = new EventEmitter();
  @Output() controlValue = new EventEmitter();
  // @Input() fieldIcon;

  @ViewChild('formControl',{static: true, read: ElementRef}) formControl: ElementRef;

  placeholder: string= '';
  validationType: string = '';
  fieldType: string  ='';
  fieldIcon: string  ='';
  enum=Constant;
  pickerToggle:boolean = false;
  disabled:boolean = false;
  timePicker: boolean = false;
  infoMsg: any;
  decimalValidationMsg: string;
  orderFormSubmitted;
  selfServiceConfig : boolean = false;
  editField : boolean = false;
  public templateData: any;
  isLoading: boolean;
  modalService: any;
  orderForm: any;
  viewComp : any;
  commonSubject : any;
  // formControlChanges$: Observable<any>;

  constructor(private cd: ChangeDetectorRef, private formService: FormService,private _eref: ElementRef, private appService: AppService, private _snackBar: CustomSnackBarService, private renderer:Renderer2, public translate: TranslateService, private alphaService : AlphaService) {}

  ngOnInit() {
    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }
    if(this.configData.timePicker){
      this.timePicker = true;
    }
    this.fieldType = this.fieldMetadata ? this.fieldMetadata.fieldType : 'search';
    this.fieldIcon = this.fieldMetadata ? this.fieldMetadata.fieldIcon : null;
    this.toggleDisable(this.configData['disabled']);
    // This should be remove when all featureNames get updated
    let menuPageAccess;
    if(this.configData["menuPageAccess"]){
      menuPageAccess = this.configData["menuPageAccess"];
    } else {
      menuPageAccess = this.configData["access"];
    }
    if (menuPageAccess) {
      this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(menuPageAccess)
    }
    //passing Object
    if (this.configData['dynamicVisibility']) {
      if(this.configData['dynamicVisibility'].action == 'hidden'){
        this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
      }else if(this.configData['dynamicVisibility'].action == 'disabled'){
        if(this.checkAccess(this.configData['dynamicVisibility'].featureName) == false){
          this.configData['disabled'] = true;
          this.frmGroup.get(this.configData.name).disable();
        }
      }
    }
    if (this.configData['editAccess']) {
      this.configData['editAccess'].forEach(row => {
        let persona;
        if(row.roleAccess){
          persona = row.roleAccess;
        } else {
          persona = row.persona;
        }
        // if(row.action == 'hidden'){
        //   this.frmGroup.get(this.configData.name)['hidden'] = !this.checkFieldAccess(persona);
        // }
        if (row.action == 'hidden' && this.checkFieldAccess(persona) == false) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData["required"] = false;
          this.frmGroup.get(this.configData.name)['required'] = false;
          this.frmGroup.get(this.configData.name).removeValidators([Validators.required]);
        }
        if(row.action == 'disabled'){
          if(this.checkFieldAccess(persona) == false){
            this.configData['disabled'] = true;
            this.frmGroup.get(this.configData.name).disable();
          }
        }
      });
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
    }
    if(this.configData.validation.length)
       this.fieldValueValidation(this.configData.validation);
      // commenting this line as it is affecting dynamic visibility of input field (as a part of E2E bug- 3572)
   // this.formControlChanges$ = this.frmGroup.get(this.configData.name).statusChanges;
   let sourceData = this.frmGroup.get(this.configData.name).value;
    let poLineSelectedData = JSON.parse(localStorage.getItem('selectedPoLines'));
    let copyOrderResData = JSON.parse(localStorage.getItem('copyOrderRes'));
    let events = this.configData?.events;
    if (events && events.length > 0) {
      let res = events.find(event => event.actionType)
      if (res && res.actionType === 'ONLOAD_SET_DATA') {
        let otmKeys;
        let result = {};
        if (poLineSelectedData !== null) {
          otmKeys = res.otmKeys;
          otmKeys.forEach(key => {
            result[key] = null;
            poLineSelectedData?.forEach(data => {
              if (data.hasOwnProperty(key)) {
                result[key] = data[key];
              }
            });
          });
          if (result[otmKeys[0]] === result[otmKeys[1]]) {
            if (res.hasOwnProperty('defaultValue')) {
              const defaultVlaueKey = res.defaultValue;
              poLineSelectedData?.forEach(data => {
                if (data.hasOwnProperty(defaultVlaueKey)) {
                  res.defaultValue = data[defaultVlaueKey]
                }
              })
            }
            this.frmGroup.get(this.configData.name).setValue(res.defaultValue)
          } else if (sourceData !== undefined && sourceData !== "") {
            this.frmGroup.get(this.configData.name).disable();
          }
        } else if (poLineSelectedData === null) {
          if (this.configData.name === 'inco_term_location') {
            this.frmGroup.get(this.configData.name).setValue(copyOrderResData?.rawData?.inco_term_location)
          }

          otmKeys = res.otmKeyscopy || [];
          otmKeys.forEach(key => {
            result[key] = null;
          });
          Object.keys(copyOrderResData).forEach(dataKey => {
            if (copyOrderResData.hasOwnProperty(dataKey)) {
              otmKeys.forEach(key => {
                if (dataKey === key) {
                  result[key] = copyOrderResData[dataKey];
                }
              })
            }
          })
          if (result[otmKeys[0]] !== result[otmKeys[1]]) {
            this.frmGroup.get(this.configData.name).disable();
          }
        }
      }
    }

    if (this.configData?.name === 'loggedInUserName') {
      let first_name = localStorage.getItem('firstName');
      let last_name = localStorage.getItem('lastName');
      let name = first_name + " " + last_name;
      this.frmGroup.get(this.configData.name).setValue(name);
    }
    this.frmGroup.get(this.configData.name).valueChanges.subscribe(value => {
      if (!this.configData.releaseQtyTolerance) {
        this.validateInput(value)
      }
    });
    if(this.configData?.validationV2?.populateFrom && !this.frmGroup.get(this.configData.name).value) this.alphaService.populateFieldsFromUserDetailApi(this.frmGroup, this.configData);
    this.frmGroup.get(this.configData.name).valueChanges.subscribe((status) => {
      const field = this.frmGroup.get(this.configData.name);
      if(this.configData?.duplicatecheckURL && field?.value != "")
      {
        const encodedValue = encodeURIComponent(field?.value.toUpperCase());
        let duplicateCheck = this.configData.apiUrl+"&searchString="+encodedValue+"&userId="+localStorage.getItem('userName')+"&customerCode="+localStorage.getItem('customerCode')+"&action=fetchClientDBA&exclude=";
        this.appService.makeHttpGetRequest(duplicateCheck).subscribe((data: any) => {
          if(data.message.statusCode === APP_Constants.SUCCESS_CODE)
          {
            field.setErrors({ 'duplicateCheck': "Location already exists in OTM" });
            this.cd.detectChanges();
          }
        });
      }
      if (field.disabled && field.errors) {
        this.configData['editable'] = false;
        field.enable({ emitEvent: false });
      }
    });

    if (this.configData?.controlSubstanceslength) {
     this.frmGroup.get(this.configData.name).valueChanges.pipe(debounceTime(CommonConfig.LOCATION_SEARCH_TIMEOUT)).subscribe(value => {
          this.handleValidation(value);
        });
      }
  }

  validateInput(value: any) {
    this.configData.validation.forEach(element => {
      let check= (typeof element === 'string' ? element : element.toString()).split('-');
      // let check = element.split('-');
      if (check[0] === 'notMoreThan') {
        if (!!this.frmGroup.getRawValue()[check[1]] && !!value && (+value > +this.frmGroup.getRawValue()[check[1]])) {
          this.frmGroup.get(this.configData.name).setErrors({ 'maxValue': this.enum.NOT_MORE_THAN });
        }
      }
    });
  }

  ngAfterViewChecked() {
    let frmGroup = this.frmGroup?.get(this.configData?.name);
    if (frmGroup['required'] === false && frmGroup?.errors?.required !== true) {
      this.configData.required = false;
    }

    if(this.configData['maxLength'] && this.frmGroup.get(this.configData.name).value){
      if (this.frmGroup.get(this.configData.name).value.length > parseInt(this.configData['maxLength'])) {
         this.frmGroup.get(this.configData.name).setErrors({ 'maxLength': { 'exceedsChar': this.frmGroup.get(this.configData.name).value.length - parseInt(this.configData['maxLength']) } });
      }
    }
    const currentValue = this.frmGroup.get(this.configData.name).value;
    if (this.configData['minLength'] && currentValue && currentValue.length > 0 && currentValue.length < parseInt(this.configData['minLength'])) {
      if (!this.frmGroup.get(this.configData.name).errors?.pattern) {
        this.frmGroup.get(this.configData.name).setErrors({ 'minLength': { 'requiredChar': parseInt(this.configData['minLength']) - currentValue.length } });
      }
    }
    if(this.configData?.validationV2?.rangeRules) {
      let input = this.frmGroup?.get(this.configData?.name)?.value;
      if(input.length > 0) this.alphaService.validateRangeRules(input, this.configData, this.frmGroup);
    }

    if(this.configData?.validationV2?.populateFrom && !this.frmGroup.get(this.configData.name).value) {
      this.alphaService.populateFieldsFromUserDetailApi(this.frmGroup, this.configData);
    }  

    if(this.configData?.validationV2?.conditionalRequired) {
      let input = this.frmGroup?.get(this.configData?.name)?.value;
      let isValid = input?.length > 0 && this.alphaService.validateRangeRules(input, this.configData, this.frmGroup);
      this.alphaService.handleConditionalRequired(this.configData, this.frmGroup, isValid);
    }  
  }

  sendVolumeDataToSource(event: DhlFormControlEvent, row = {} ) {
    let eventData: DhlFormControlEventData = {
      action: 'VOLUME_CALCULATION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: row,
      event: 'CREATE_ORDER',
      eventData: undefined
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  ngAfterViewInit(){
    // it is hard coded, should removed soon
    if(this.configData.name.toUpperCase().indexOf('DATE') != -1){
      this.renderer.removeClass(this.formControl.nativeElement , 'error');
    }
    this.placeholder = this.configData.placeHolder;
    if (this.frmGroup.get(this.configData.name).value && Object.keys(this.frmGroup.get(this.configData.name).value).length && 
      this.frmGroup.get(this.configData.name).value.hasOwnProperty("value")) {
      if (!(this.configData.component == "DATEPICKER_V2" && this.configData['dataType'] == 'OBJECT')) { //CP-2434
        this.frmGroup.get(this.configData.name).setValue(this.frmGroup.get(this.configData.name).value.value)
      }
    } else if (this.frmGroup.get(this.configData.name).value != '') {
      this.frmGroup.get(this.configData.name).setValue(this.frmGroup.get(this.configData.name).value)
    }

    // if(this.configData.component == "DATEPICKER_V2" && !this.configData.timePicker){
    //   this.frmGroup.get(this.configData.name).addValidators(this.appService.setDateValidator(this.configData));
    // }

    if(this.configData['comparison']){
      this.infoMsg = this.appService.compareTwoNumericFields(this.configData, this.frmGroup);
    }

    if (this.configData['dynamicWarningMsg']) {
      this.infoMsg = this.appService.dynamicWarningMsg(this.configData, this.frmGroup, '');
    }
    if(this.configData?.dynamicDependentCom && this.frmGroup?.get(this.configData.name)?.value != ''){
      this.frmGroup.get(this.configData?.dynamicDependentCom).setValue(this.frmGroup?.get(this.configData.name)?.value)
    }
    this.commonSubject = this.appService._commonComponentSubject.subscribe(
      (res) => {
        if (res?.action == "ADD_REMOVE_ROW" && res?.configData?.controls?.filter((val) => val?.name == "weight")[0]?.validation?.indexOf("MoreThanWeight-weightPo") > -1) {
          setTimeout(() => {
            this.totalWeightFn();
          }, 0);
        }
        this.commonSubject.unsubscribe();
      }
    );
    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj?.[this.configData.name]) {
      this.frmGroup.get(this.configData.name).setValue(filterObj[this.configData.name]);
    }

    if(this.configData?.validationV2?.populateFrom && !this.frmGroup.get(this.configData.name).value) this.alphaService.populateFieldsFromUserDetailApi(this.frmGroup, this.configData);

    if (this.frmGroup.get(this.configData.name)) {
      const manageAffectedColumnData = typeof this.frmGroup.get(this.configData.name)?.value === 'string' ? this.frmGroup.get(this.configData.name)?.value.trim() : this.frmGroup.get(this.configData.name)?.value;
      this.alphaService.manageAffectedColumn(this.configData, this.frmGroup, manageAffectedColumnData, false);
    }
  }

  fieldValueValidation(validations){
    validations.forEach((validataion:string | any) => {
      let element =  (typeof validataion == "object" ? validataion.name : validataion);

      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
      	  this.frmGroup.get(this.configData.name)['required'] = false;
          //this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).removeValidators([Validators.required]);
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
      
      if (element === "NoNumber") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp(/^[^\d]*$/)));
      }
      if (element === "Numeric") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.min(1));
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^0*[1-9]\\d*$')));
      }
      else if (element === "NumericWithZero") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.min(0));
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^0*[0-9]\\d*$')));
      }
      else if (element === 'Decimal') {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.min(1));
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^\\s*(?=.*[1-9])\\d*(?:\\.\\d{1,99})?\\s*$')));
      }

      else if (element === 'DecimalWithMaxlength') {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp(/^\s*(?=.*[1-9])\d{1,3}(?:\.\d{1,2})?\s*$/)));
      }
      else if (element === 'DecimalWith2Places') {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/)));
      }
      else if (element === 'DecimalWith2PlacesWithZero') {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp(/^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/)));
      }
      else if (element.split("_")[0] === 'DecimalWithPlaces') {
        this.validationType = element.split("_");
        this.decimalValidationMsg='Numeric '+ this.validationType[1]+' decimal places value to be entered.'
        //this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^[0-9]{1,11}(?:\.[0-9]{1,'+this.validationType[1]+'})?$')));
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp(`^\\d+(\\.\\d{1,${this.validationType[1]}})?$`)));
      }
      if (element === "NoSpecialCharacter") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp('^((?![$<>?%&*#!~`]).)*$')));
      }
      if (element === "twoDecimalWithoutZero") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp(/^(?!0$)(?!0\.0*$)\d+(\.\d{1,2})?$/)));
      }
      if (element === "DisableAllSpecialCharacters") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp('^[a-zA-Z0-9]*$')));
      }

      if (element === "DisableSpecialCharsExceptSpaceAndUnderscore") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp('^[a-zA-Z0-9 _]*$')));
      }
      if (element === "NoSpecialCharUnDash") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(/^[\w\-]*$/));
      }
      if (element === "OTMRestrictedSpecialChars") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp('^((?![&<]).)*$')));
      }
       // only doubble quotes need to be exclude from the text box - PORTALNA-8877
       if (element === "NoSpecialCharacterDq") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp('^((?!["]).)*$')));
      }
      // This RegEx accepts many special characters
      if (element === 'Email') {
        let newexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(newexp));
      }
      // This RegEx accepts only @,.,- and _ special characters
      if (element === 'Email_V2') {
        let newexp = /^(([^<>()\[\]\\.#$;,*!&\/^?+=%{}|:\s@"]+(\.[^<>()\[\]\\.#$;,*!&\/^?+=:%{}|\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(newexp));
      }
      if (element === "customValidation") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(this.customValidator(validataion));
      }
      if (this.configData['FixedCharValidation']) {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp('^\\d{'+this.configData['FixedCharValidation']+'}$')));
      }
      if (element === "disablePastDate") {
        this.frmGroup.get(this.configData.name).addValidators(this.appService.checkPastDate(this.configData));
      }
      if (element === "disableFutureDate") {
        this.frmGroup.get(this.configData.name).addValidators(this.appService.checkFutureDate(this.configData));
      }
      if (element === "allowOneMonthPast") {
        this.frmGroup.get(this.configData.name).addValidators(this.appService.checkOneMonthPast(this.configData));
      }
      if (element === 'DecimalWith2PlacesCustomMsg') {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp(/^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/)));
      }
      if (element === 'NoSpecialCharacterPhone') {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp(/^[0-9.;\-\+]+(?:\s[0-9.;\-\+]+)*$/)));
      }
      if (element === 'XWithDateAndRandomDigits') {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).addValidators(Validators.pattern(new RegExp(/^X\d{4}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{6}$/)));
      }
    }, this);
  }

  // disableFormField(disabled){
  //   if (disabled) {
  //     this.frmGroup.get(this.configData.name).disable();
  //   }
  // }

  toggleDisable(disabled){
    // this.configData.required = disabled ? !disabled : this.configData.required;
    if (disabled === true) {
      this.frmGroup.get(this.configData.name).disable();
        // this.formControl.nativeElement.parentElement.classList.add('disabled');
      // var x = document.getElementsByClassName('disabled-icon');
      // for (let i = 0; i<x.length;i++){
      //  let j = x.item(i) as HTMLElement
      //  j.style.display="block";
      // }
      // var x = document.getElementsByClassName('default-icon');
      // for (let i = 0; i<x.length;i++){
      //  let j = x.item(i) as HTMLElement
      //  j.style.display="none";
      // }
    } else{
      this.frmGroup.get(this.configData.name).enable();
    //   this.formControl.nativeElement.parentElement.classList.remove('disabled');
    //   var x = document.getElementsByClassName('disabled-icon');
    //   for (let i = 0; i<x.length;i++){
    //    let j = x.item(i) as HTMLElement
    //    j.style.display="none" ;
    //   }
    //   var x = document.getElementsByClassName('default-icon');
    //   for (let i = 0; i<x.length;i++){
    //    let j = x.item(i) as HTMLElement
    //    j.style.display="block";
    //   }
    }
  }

  clearFieldValue(){
    this.frmGroup.get(this.configData.name).reset();
  }
  
toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden'], required?) {  
  this.cd.markForCheck();  
  if(required === "false"){
    this.configData.required = hidden ? !hidden : this.configData.required;    // if fied is visible, it will be mandatory because we loose initial required data
  } else {
    this.configData.required = !hidden
    this.frmGroup.get(this.configData.name)['required'] = !hidden;
  }
  this.frmGroup.get(this.configData.name)['hidden'] = hidden;
  if (hidden === true) {      
    this.frmGroup.get(this.configData.name).reset();  // reset with initial form having blank value, do not remove the required validation      
    this.frmGroup.get(this.configData.name).setErrors(null);  // to remove required valisation from form in case of hidden                  
    //this.frmGroup.get(this.configData.name).clearValidators();
    this.frmGroup.get(this.configData.name).removeValidators([Validators.required]);
    this.frmGroup.get(this.configData.name).updateValueAndValidity();
  } else {      
    if(this.configData.required){
      this.frmGroup.get(this.configData.name).addValidators([Validators.required]);
      this.frmGroup.get(this.configData.name).updateValueAndValidity();   
    }  
    if (this.configData.validation.length) {
       this.fieldValueValidation(this.configData.validation);
    }
    if (this.configData['editAccess']) {
      this.configData['editAccess'].forEach(row => {
        let persona;
        if(row.roleAccess){
          persona = row.roleAccess;
        } else {
          persona = row.persona;
        }

        if (row.action == 'hidden' && this.checkFieldAccess(persona) == false) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData["required"] = false;
          this.frmGroup.get(this.configData.name)['required'] = false;
          this.frmGroup.get(this.configData.name).removeValidators([Validators.required]);
        }
      });
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
    }
    if(!this.frmGroup.get(this.configData.name).value || this.frmGroup.get(this.configData.name).value === '' || this.frmGroup.get(this.configData.name).value === undefined) {
      this.frmGroup.get(this.configData.name).setValue(this.configData.defaultValue.value);
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
    }
  }        
}

  customValidator(validataionProps): ValidatorFn{
    let me = this;
    return (control): { [key: string]: any } | null => {
      let sourceControl = me.frmGroup.get(validataionProps['sourceControl']);
      if(!control.value || !sourceControl || !sourceControl.value || !sourceControl.value.value){
        return null;
      }
      let option = validataionProps.options.filter(option => option.value ==  sourceControl.value.value)[0];
      let newRegExp = new RegExp(option.pattern.toString());
      let forbidden = newRegExp.test(control.value);
      let validationMessage = option.message;
      control.markAsTouched();
      return !forbidden ? { customValidation: { value: control.value, 'message': validationMessage } } : null;
    }
  }

  onWindowClick(event) {
    if (!this._eref.nativeElement.contains(event.target))
      this.pickerToggle = false;
  }

  popFieldAction(e){
    this.fieldAction.emit(e);
  }

  transformFormValue(){
    if(this.configData.component=='DATEPICKER_V2'){
      // return this.formService.getDateFormat(new Date(this.frmGroup.get(this.configData.name).valueChanges));
    }
  }
  ValueChange(){
    if(this.configData['maxLength'] && this.frmGroup.get(this.configData.name).value) {
      if (this.frmGroup.get(this.configData.name).value.length > parseInt(this.configData['maxLength'])) {
       this.frmGroup.get(this.configData.name).setErrors({ 'maxLength': { 'exceedsChar': this.frmGroup.get(this.configData.name).value.length - parseInt(this.configData['maxLength']) } });
      }
    }
  }


  controlValueChange(e, keepAffectedColumnValues = false){
    // this.controlValue.emit(e);
    this.frmGroup.get(this.configData.name).setValue(e?.target?.value?.trim());
    if(this.configData.component === 'DATEPICKER_V2'){
      this.appService.compareTwoDates(e, this.configData, this.frmGroup);
    }
    if(this.configData['comparison']){
      this.infoMsg = this.appService.compareTwoNumericFields(this.configData, this.frmGroup);
    }
    if (this.configData['minLength'] && e.target.value.length > 0 && e.target.value.length < parseInt(this.configData['minLength'])) {
      if (!this.frmGroup.get(this.configData.name).errors?.pattern) {
        this.frmGroup.get(this.configData.name).setErrors({ 'minLength': { 'requiredChar': parseInt(this.configData['minLength']) - e?.target?.value?.length } });
      }
    }
    if (this.configData["textCaps"] && !this.frmGroup.get(this.configData.name).errors ) {
      this.frmGroup.get(this.configData.name).setValue(e?.target?.value?.toUpperCase());
    }
	 if(this.configData.events){
      this.onCommonEventHander('SET_VALUE');
    }

    if(this.configData?.validationV2?.rangeRules) {
      let input = this.frmGroup?.get(this.configData?.name)?.value;
      if(input.length > 0) this.alphaService.validateRangeRules(input, this.configData, this.frmGroup);
    }

    if(this.configData?.validationV2?.conditionalRequired) {
      let input = this.frmGroup?.get(this.configData?.name)?.value;
      let isValid = input?.length > 0 && this.alphaService.validateRangeRules(input, this.configData, this.frmGroup);
      this.alphaService.handleConditionalRequired(this.configData, this.frmGroup, isValid);
    }

     //send uom dropdown values to rateLookup screen.
     if(this.configData.volCalculation){
      let event: DhlFormControlEvent
      setTimeout(() => {
        this.sendVolumeDataToSource(event, this.frmGroup.value);
      })
    }
    //end
    //Form Group validation services
    this.formService.groupValidationSrv(this.configData, this.frmGroup);

    this.configData.validation.forEach(element => {
      let check = element.split('-');
      if (this.configData.releaseQtyTolerance){
        const currentValue = +this.frmGroup.get(this.configData.name).value;
        const rawValue = +this.frmGroup.getRawValue()[check[1]];
        const tolerance = Math.round(rawValue / 100 * this.configData.releaseQtyTolerance);
      if (check[0] === 'notMoreThan') {
          if (currentValue > rawValue + tolerance ) {
            this.frmGroup.get(this.configData.name).setErrors({ 'maxValue': this.enum.NOT_MORE_THAN_TOLERANCE });
          }
        }
      }
      else if(check[0] === 'notMoreThan') {
        if (+this.frmGroup.get(this.configData.name).value > +this.frmGroup.getRawValue()[check[1]]) {
          this.frmGroup.get(this.configData.name).setErrors({ 'maxValue': this.enum.NOT_MORE_THAN });
        }
      }
      else if (check[0] === 'MoreThanWeight') {
        this.totalWeightFn();
      }
      else if(check[0] === 'notMoreThanAddition') {
        let currentFieldValue = this.frmGroup.get(this.configData.name).value,
        nextFieldValue = 0,
        withoutFirst = check.slice(1);
        withoutFirst.forEach((el) => nextFieldValue += Number(this.frmGroup.get(el)?.value));
        if (Number(currentFieldValue) > Number(nextFieldValue)) {
          this.frmGroup.get(this.configData.name).setErrors({ 'maxValue': this.enum.NOT_MORE_THAN });
        }
      } else if (element === 'Numeric' && this.configData.isRequired) {
        const control = this.frmGroup.get(this.configData.name);
        const validators = [Validators.pattern(new RegExp('^0*[1-9]\\d*$'))];
        if (this.configData.isRequired === true) {
          validators.push(Validators.required);
        }
        control.setValidators(validators);
        control.updateValueAndValidity();
        if (control.errors) {
          if (control.errors['pattern']) {
            control.setErrors({ 'positiveNumber': 'Only Positive Numbers Allowed' });
          } else if (control.errors['required']) {
            control.setErrors({ 'required': 'This field is required' });
          } else {
            control.setErrors(null);
          }
        }
      } else if (check[1] === 'notMoreThanValue') {
        let formgroupData = this.frmGroup?.parent?.parent.getRawValue(),
          totalItemCount = 0,
          totalHuCount = 0,
          fieldName = check[0].split('_'),
          nextFieldName = check[2].split('_');

        if (formgroupData && formgroupData !== undefined) {
          formgroupData[fieldName[0]].forEach(group => {
          if (Object.keys(group).includes(fieldName[1])) {
            totalHuCount += Number(group[fieldName[1]]);
          }
        }, this);

        formgroupData[nextFieldName[0]].forEach(group => {
          if (Object.keys(group).includes(nextFieldName[1])) {
            totalItemCount += Number(group[nextFieldName[1]]);
          }
        }, this);

        if (totalItemCount < totalHuCount) {
          this.frmGroup.get(this.configData.name).setErrors({ 'maxValue': this.configData['errorMessage'] });
        } else {
          let shipGroup = this.frmGroup?.parent?.parent?.get(fieldName[0])['controls'],
            lineGroup = this.frmGroup?.parent?.parent?.get(nextFieldName[0])['controls'],
            fieldsComp, fieldsArrayGroup;

          for (const comp in shipGroup) {
            fieldsArrayGroup = <UntypedFormGroup>shipGroup[comp];
            if (typeof fieldsArrayGroup === 'object') fieldsComp = fieldsArrayGroup?.get(fieldName[1]);
            if (!isNaN(+comp) && !!fieldsComp?.errors?.maxValue) fieldsComp?.setErrors(null);
          }

          for (const comp in lineGroup) {
            fieldsArrayGroup = <UntypedFormGroup>lineGroup[comp];
            if (typeof fieldsArrayGroup === 'object') fieldsComp = fieldsArrayGroup?.get(nextFieldName[1]);
            if (!isNaN(+comp) && !!fieldsComp?.errors?.maxValue) fieldsComp?.setErrors(null);
          }
        }
      }
      else {
        const rawValue = this.frmGroup?.value;
        const currentvalue = rawValue?.[check[0]];
        const comparisionValue = rawValue?.[check[2]];
        const currentfiledControl = this.frmGroup.get(check[2]);
        const perviousFieldControl = this.frmGroup.get(check[0]);
        let input;
        let rangeValidationErrorField1;
        let rangeValidationErrorField2 = true;
        if (this.configData?.validationV2?.rangeRules) {
          input = this.frmGroup?.get(this.configData?.name)?.value;
          if (input?.length > 0) {
            rangeValidationErrorField1 = this.alphaService.validateRangeRules(input, this.configData, this.frmGroup);
            if (!rangeValidationErrorField1) {
              this.frmGroup.get(this.configData.name).setErrors({ 'maxValue': this.configData?.validationV2?.rangeRules[0].errorMessage });
            }
          }
        }
        if (currentvalue !== '' && comparisionValue !== '') {
          if (input === currentvalue) {
            rangeValidationErrorField2 = this.alphaService.validateRangeRules(comparisionValue, this.configData, this.frmGroup);
          }
          if (!rangeValidationErrorField2 && rangeValidationErrorField1) {
            currentfiledControl.setErrors({ 'maxValue': this.configData?.validationV2?.rangeRules[0].errorMessage });
            perviousFieldControl.setErrors(null);
          }
          else if (rangeValidationErrorField1 && rangeValidationErrorField2 && Number(currentvalue) > Number(comparisionValue)) {
            this.frmGroup.get(this.configData.name).setErrors({ 'maxValue': this.configData['errorMessage'] });
          }
          else if (rangeValidationErrorField1 && rangeValidationErrorField2 && (Number(currentvalue) <= Number(comparisionValue))) {
            currentfiledControl.setErrors(null);
            perviousFieldControl.setErrors(null);
          }
        }
      }
      } 
    }, this);
    this.alphaService.manageAffectedColumn(this.configData, this.frmGroup, e?.target?.value.trim(), keepAffectedColumnValues);
  }
  totalWeightFn () {
    let formgroupData = this.frmGroup?.parent?.parent?.getRawValue();
    let totalPOWeight = 0;
    let totalShipUnitCount = 0;
    formgroupData?.poLines?.forEach(group => {
      if (Object.keys(group).includes("weightPo")) {
        totalPOWeight += +group["weightPo"];
      }
    }, this)
    formgroupData?.shipCard?.forEach(group => {
      if (Object.keys(group).includes("weight")) {
        let huCount = group["huCount"] || 1;
        totalShipUnitCount += (+group["weight"] * huCount);
      };
    }, this);
    let shipUnitGroup = this.frmGroup?.parent?.controls;

    for (const comp in shipUnitGroup) {
      if(!isNaN(+comp)){
        let fieldsArrayGroup = <UntypedFormGroup>shipUnitGroup[comp];
        let fieldsComp = fieldsArrayGroup?.get("weight");

        if (totalPOWeight > totalShipUnitCount) {
          if (!isNaN(+comp) && !fieldsComp?.errors) {
            fieldsComp.setErrors({
              maxValue:
                "Total of all Handling Unit Weight should not be less than PO Weight",
            });
          }
        } else {
          if (!isNaN(+comp) && !!fieldsComp?.errors?.maxValue)
            fieldsComp.setErrors(null);
        }
      }
    }
  }

  editContent(event){
    if(this.configData.validation.indexOf("PartialEdit") && this.configData.hasOwnProperty('limitPartialEdit') && this.configData["limitPartialEdit"]){
      if(event.keyCode < 35 || event.keyCode > 40){
        if((event.keyCode == 8 && event.currentTarget.selectionStart <= this.configData["limitPartialEdit"])
            || event.keyCode == 46 && event.currentTarget.selectionStart < this.configData["limitPartialEdit"]){
            event.preventDefault();
            this._snackBar.open( { orderId: '', message: 'First ' + this.configData["limitPartialEdit"] + ' characters of ' + this.configData["label"] + ' are not editable.' }, { duration: 2000 });
            return;
        }else if(event.keyCode != 8 && event.keyCode != 46 && event.currentTarget.selectionStart < this.configData["limitPartialEdit"]){
          event.preventDefault();
          this._snackBar.open( { orderId: '', message: 'First ' + this.configData["limitPartialEdit"] + ' characters of ' + this.configData["label"] + ' are not editable.' }, { duration: 2000 });
          return;
        }else if(this.frmGroup.get(this.configData.name).value.length >= this.configData["limitPartialEdit"]
            && event.currentTarget.selectionStart < this.configData["limitPartialEdit"]){
              event.preventDefault();
              this._snackBar.open( { orderId: '', message: 'First ' + this.configData["limitPartialEdit"] + ' characters of ' + this.configData["label"] + ' are not editable.' }, { duration: 2000 });
              return;
        }else if (this.frmGroup.get(this.configData.name).value.length < this.configData["limitPartialEdit"] ){
          event.preventDefault();
          this._snackBar.open( { orderId: '', message: this.configData["label"] + ' with length less than ' + (this.configData["limitPartialEdit"] + 1) + ' characters are not editable.' }, { duration: 2000 });
          return;
        }
      }
    }
  }

  setValueToControl(value){
    if (value != undefined) {
      this.frmGroup.get(this.configData.name).setValue(value);
    }
  }

  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);
  }
  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }
  onCommonEventHander(eventType, value = null) {
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, eventType);
    let allow = false;
    if(event){
      allow =  (event['eventOnDisable'] === true && this.configData['disabled'] === true) || event['eventOnDisable'] === undefined;
    }
    if (this.frmGroup.get(this.configData.name).valid || allow) {
      let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, eventType);
      if (event) {
          this.sendToSource(event);
      }
      else if(!event  && this.configData["enableFilterSaveButton"]){
        this.sendToSource({"actionType" : "ENABLE_SAVE"});
      }
    }
  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      if (event.length === 1) {
        event = event[0];
      } else if (event.length > 1) {
        event = event;
      } else { event = null }
    }
    return event;
  }

  sendToSource(event, data = {}) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.actionType || 'MULTIPLE_ACTION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: this.frmGroup.get(this.configData.name).value
    }
    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj) {
      filterObj[this.configData.name] = this.frmGroup.get(this.configData.name).value;
      this.alphaService.setFilteredObject('setFiltersValues', filterObj);
    }
    if (event.actionType === "ENABLE_SAVE" && this.configData["enableFilterSaveButton"]) {
      this.appService._commonComponentSubjectFilter.next(eventData);
    }
    else {
      this.appService._commonComponentSubject.next(eventData);
    }  
  }

  fetchValues(event){
    event.stopPropagation();
    if(this.configData['autoFill']){
      if(this.configData.events){
        this.onCommonEventHander('SET_VALUE_CHANGE');
      }
    }
    if(this.configData.events){
      this.onCommonEventHander('SET_VALUE');
    }
    if(this.configData?.dynamicDependentCom){
      this.frmGroup.get(this.configData?.dynamicDependentCom).setValue((event.target as HTMLInputElement).value)
    }
    if(this.configData['enableFilterSaveButton']){
      this.frmGroup.get(this.configData.name).setValue(event.currentTarget.value);
      this.sendToSource({"actionType" : "ENABLE_SAVE"});
    }
  }
   
  formatResponse(data) {
    let refnumData = {};
    let remarkData = {};
    
    for (let valueKey in data.value.refNums) {
      let refnumLabel = data.value.refNums[valueKey].displayValue;
      let refnumValue = data.value.refNums[valueKey].refnumValue;
      data.value[refnumLabel] = refnumValue;
    }
    for (let valueKey in data.value.remarks) {
      let remarkLabel = data.value.remarks[valueKey].displayValue;
      let remarkValue = data.value.remarks[valueKey].remarkText;
      data.value[remarkLabel] = remarkValue;
    }
    return data;
    // Use `key` and `value`
    // let step1 = [], step2 = [], step3 = [];
    // step1[0] = Object.assign({}, data.value, refnumData, remarkData);
    // step2[0] = Object.assign({}, data.value, refnumData, remarkData);
    // step3[0] = Object.assign({}, data.value, refnumData, remarkData);
    // let formattedResponse = { "stepOne": step1, "stepTwo": step2, "stepThree": step3 };
    // return  Object.assign({}, data.value, refnumData, remarkData);
  }

  normalView() {
    throw new Error('Method not implemented.');
  }

  pwsMaskingFn = (status)=>{
    this.configData.type = (status) ? 'password' : 'password-show';
  }

  setDefaultValueOnReset() {
    if(this.configData?.validationV2?.populateFrom && !this.frmGroup.get(this.configData.name).value) this.alphaService.populateFieldsFromUserDetailApi(this.frmGroup, this.configData);
  }

  handleValidation(value: string) {
    const control = this.frmGroup.get(this.configData.name);
    const minLength = parseInt(this.configData['controlSubstanceslength']);
    this.infoMsg = '';
    if (this.configData['controlSubstanceslength']) {
      if (value?.length < minLength && value?.length !== 0) {
        control.setErrors({ 'minLength': { 'requiredChar': minLength - (value ? value?.length : 0) } });
      } else if (value?.length === 0) {
        this.infoMsg = '';
      } else {
        this.controlSubstanceValueChange();
      }
    }
    this.cd.detectChanges();
  }

  controlSubstanceValueChange() {
    const { name, apiUrl } = this.configData;

    const originCountry = this.appService?._components['shipFromCountry']?.frmGroup?.get('shipFromCountry')?.value;
    const destinationCountry = this.appService?._components['shipToCountry']?.frmGroup?.get('shipToCountry')?.value;
    const userId = localStorage.getItem('userName');
    const customerCode = localStorage.getItem('customerCode');
    const mainControl = this.alphaService.getControl(name, this.frmGroup)?.control;
    mainControl.value = decodeURIComponent(mainControl.value);
    mainControl.value = encodeURIComponent(mainControl.value);

    const url = `${apiUrl}${name}` +
      `&searchString=${mainControl.value}` +
      `&userId=${userId}` +
      `&customerCode=${customerCode}` +
      `&shipFromCountry=${originCountry}` +
      `&shipToCountry=${destinationCountry}`;

    this.appService.makeHttpGetRequest(url).subscribe((data: any) => {
      mainControl.value = decodeURIComponent(mainControl.value);

      if (!mainControl) {
        return;
      }

      switch (data.statusMessage) {
        case APP_Constants.MATCH:
          if (this.configData['dynamicWarningMsg']) {
            this.infoMsg = this.appService.dynamicWarningMsg(this.configData, this.frmGroup, data.statusMessage);
          }
          break;
        case APP_Constants.MULTIPLE_MATCH:
          this.infoMsg = this.appService.dynamicWarningMsg(this.configData, this.frmGroup, data.statusMessage);
          break;
        case APP_Constants.NO_MATCH:
          this.infoMsg = this.appService.dynamicWarningMsg(this.configData, this.frmGroup, data.statusMessage);
          mainControl.setErrors(null);
          break;
      }

      this.cd.detectChanges();
    });
  }

  ngOnDestroy () {
    this.commonSubject.unsubscribe();
  }
}
